
export { AuthService as AuthServiceV2 } from '../appv2/services/auth.service';
export { MsalBroadcastService, MsalService, MSAL_INSTANCE } from "@azure/msal-angular";
export { Configuration, IPublicClientApplication, PublicClientApplication } from "@azure/msal-browser";